import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiWorkInHand from '../../Api/ApiWorkInHand';
import ToastMsg from '../../Components/ToastMsg';
import { creators as WorkInHandActions } from '../../Reducers/Reporting/WorkInHand';

export function* getWorkInHandSummary({ payload }) {
  try {
    const response = yield call(ApiWorkInHand.getSummary, payload.dimDate);

    if (response.status === 200) {
      yield put(WorkInHandActions.workinhandSuccess({ summaryData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Work In Hand Summary',
            text: response.message,
          },
        },
      );
      yield put(WorkInHandActions.workinhandFailure(response.message));
    }
  } catch (e) {
    yield put(WorkInHandActions.workinhandFailure(e));
  }
}

export function* getWorkInHandDetail({ payload }) {
  try {
    const response = yield call(ApiWorkInHand.getDetail, payload.dimDate);

    if (response.status === 200) {
      yield put(WorkInHandActions.workinhandSuccess({ detailData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Work In Hand Detail',
            text: response.message,
          },
        },
      );
      yield put(WorkInHandActions.workinhandFailure(response.message));
    }
  } catch (e) {
    yield put(WorkInHandActions.workinhandFailure(e));
  }
}
